import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Stores from '@/pages/Stores';
import Banks from '@/pages/Banks';
import Assets from '@/pages/Assets';
import Transactions from '@/pages/Transactions';
import Reports from '@/pages/Reports';
import Budgets from '@/pages/Budgets';
import Accounts from '@/pages/Accounts';
import Users from '@/pages/Users';
import Roles from '@/pages/Roles';
import Loans from '@/pages/Loans';
import Suppliers from '@/pages/Suppliers';
import Calculadora from '@/pages/Calculadora';
import Layout from '@/components/Layout';

// RRHH Pages
import SystemSelector from '@/pages/SystemSelector';
import HRLayout from '@/components/HRLayout';
import HRCatalogs from '@/pages/HRCatalogs';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUser(null);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Determinar si el usuario tiene acceso a ambos sistemas
  const hasMultipleAccess = user?.has_accounting_access && user?.has_hr_access;

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/" replace />
            ) : (
              <Login onLogin={handleLogin} />
            )
          }
        />
        
        {/* Selector de Sistema (cuando tiene acceso a ambos) */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              hasMultipleAccess ? (
                <SystemSelector />
              ) : user?.has_hr_access ? (
                <Navigate to="/rrhh/catalogo/general" replace />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* Sistema Contable */}
        <Route
          path="/dashboard"
          element={
            isAuthenticated && user?.has_accounting_access ? (
              <Layout user={user} onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        >
          <Route index element={<Dashboard />} />
        </Route>
        
        <Route
          element={
            isAuthenticated && user?.has_accounting_access ? (
              <Layout user={user} onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        >
          <Route path="tiendas" element={<Stores />} />
          <Route path="bancos" element={<Banks />} />
          <Route path="activos" element={<Assets />} />
          <Route path="transacciones" element={<Transactions />} />
          <Route path="reportes" element={<Reports />} />
          <Route path="presupuestos" element={<Budgets />} />
          <Route path="prestamos" element={<Loans />} />
          <Route path="proveedores" element={<Suppliers />} />
          <Route path="cuentas" element={<Accounts />} />
          <Route path="usuarios" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          <Route path="calculadora" element={<Calculadora />} />
        </Route>

        {/* Sistema RRHH */}
        <Route
          path="/rrhh/*"
          element={
            isAuthenticated && user?.has_hr_access ? (
              <HRLayout>
                <Routes>
                  <Route path="catalogo/general" element={<HRCatalogs />} />
                  <Route path="catalogo/empresa" element={<HRCatalogs />} />
                  <Route path="empleados" element={<div className="text-center py-20 text-slate-500">Módulo de Empleados - Próximamente</div>} />
                  <Route path="movimientos" element={<div className="text-center py-20 text-slate-500">Módulo de Movimientos - Próximamente</div>} />
                  <Route path="reportes" element={<div className="text-center py-20 text-slate-500">Reportes RRHH - Próximamente</div>} />
                </Routes>
              </HRLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
